import {
  SET_PORTAL,
  UPDATE_PORTAL_SUCCESS,
  CHANGE_PORTAL,
  ADD_GALLERY_IMAGE,
  ADD_LINK,
  ADD_PROMOTION,
  REMOVE_PROMOTION,
  ADD_LINK_IMAGE,
  REMOVE_LINK,
  REMOVE_IMAGE_LIST_ITEM
} from '../constants/index'
import * as service from '../modules/portal-remote/portalService'

export const setPortal = portal => ({
  type: SET_PORTAL,
  portal,
})

export const updatePortal = portal => async dispatch => {
  await service.updatePortal(portal)
  dispatch({ type: UPDATE_PORTAL_SUCCESS})
  // dispatch(setPortal(portal))
}

export const changePortal = (path, value) => ({
  type: CHANGE_PORTAL,
  path,
  value,
})

export const addLink = link => ({ type: ADD_LINK, link })

export const removeLink = index => ({ type: REMOVE_LINK, index})

export const removeImageListItem = index => ({ type: REMOVE_IMAGE_LIST_ITEM, index})

export const addPromotion = promotion => ({ type: ADD_PROMOTION, promotion })

export const removePromotion = index => ({ type: REMOVE_PROMOTION, index })

// MARK: Images
export const addGalleryImage = ref => ({ type: ADD_GALLERY_IMAGE, ref })

export const addLinkImage = (ref, linkIndex) => ({
  type: ADD_LINK_IMAGE,
  ref,
  linkIndex,
})



// WEBPACK FOOTER //
// ./src/actions/portal.js